import { firestore } from '../utils/firebase'
import { ParameterError } from '../utils/customErrors'

export default class Activity {
    static async create({title, description, link, speaker, hour, date}) {
        if (typeof title !== 'string' || typeof description !== 'string' || typeof link !== 'string' ||
            typeof(speaker) !== 'string' || typeof(hour) !== 'string' || typeof(date) !== 'string') {
            throw new ParameterError('incorrect parameter')
        }

        await firestore.collection('activities').add({
            title,
            description,
            speaker,
            hour,
            date,
            link
        })
    }

    static async search(id){
    if(typeof(id) !== 'string'){
        throw new ParameterError('Incorrect parameter')
        }
    
        return firestore.collection('activities').doc(id).get().then(response => {
        return Object.assign({id: response.id}, response.data())
        })
    }

    static async readByDate(date){

        if(typeof(date) !== 'string'){
            throw new ParameterError('incorrect parameter')
        }

        return firestore.collection('activities').where('date', '==', date).get().then(response => {
            return response.docs.map(doc => {
                return Object.assign({ id: doc.id }, doc.data())
            }).sort((obj1, obj2) => {
                return ( obj1.hour > obj2.hour) ? 1 : ( obj1.hour < obj2.hour) ? -1 : 0
            })
        })

        

    }

    static async read() {

        return await firestore.collection('activities').get().then(querySnapshot => {
            return querySnapshot.docs.map(doc => {
                return Object.assign({ id: doc.id }, doc.data())
            }).sort((obj1, obj2) => {
                return ( obj1.date > obj2.date) ? 1 : ( obj1.date < obj2.date) ? -1 : 0
            })
        })

    }

    static async update({ id, ...activity }) {
        const allowedProperties = ['title', 'description', 'speaker', 'hour', 'date', 'link']

        const formatIsInvalid = Object.keys(activity).some(property => !allowedProperties.includes(property))

        if (typeof id !== 'string') {
            throw new ParameterError('incorrect id')
        }

        if (Object.keys(activity).length === 0) {
            throw new ParameterError('nothing to update')
        }

        if (formatIsInvalid) {
            throw new ParameterError('unknown parameter sent')
        }

        await firestore.collection('activities').doc(id).update({ ...activity })
    }

    static async delete(id) {
        if (typeof id !== 'string') {
            throw new ParameterError('incorrect id')
        }

        await firestore.collection('activities').doc(id).delete()
    }
}